export const ADMIN_MFA_REQUIRED_CODE = 'ADMIN_MFA_REQUIRED';

export const isAdminMfaRequiredError = (error: unknown): boolean => {
  if (!error || typeof error !== 'object') {
    return false;
  }

  const graphQLErrors = (
    error as {
      graphQLErrors?: Array<{
        extensions?: {
          code?: string;
          response?: { error?: string };
        };
      }>;
    }
  ).graphQLErrors;

  return (graphQLErrors ?? []).some(
    ({ extensions }) =>
      extensions?.code === ADMIN_MFA_REQUIRED_CODE ||
      extensions?.response?.error === ADMIN_MFA_REQUIRED_CODE,
  );
};
